<template>
  <div paddingless-mobile>
    <div class="max-w-3xl">
      <d-card>
        <v-form
          ref="form"
          :data="form"
          :url="endpoint.url"
          :method="endpoint.method"
          @success="$router.go(-1)"
        >
          <d-card-row>
            <v-input
              v-model="form.name"
              required
              name="name"
            />
          </d-card-row>

          <d-card-row>
            <v-input
              v-model="form.email"
              name="email"
              required
            />
          </d-card-row>

          <d-card-row>
            <v-input
              v-model="form.password"
              name="password"
              required
              :label="passwordLabel"
              type="password"
              :password-reveal="true"
            />
          </d-card-row>

          <d-card-row>
            <v-input
              v-model="form.phone"
              name="phone"
            />
          </d-card-row>

          <d-card-row>
            <v-input
              v-model="form.assigned_task"
              name="assigned_task"
            />
          </d-card-row>

          <d-card-row>
            <v-input
              v-model="form.role"
              name="role"
            />
          </d-card-row>

          <d-card-row>
            <v-input-date
              v-model="form.birthday"
              position="is-top-right"
              name="birthday"
            />
          </d-card-row>

          <d-card-row>
            <v-input-switch
              v-model="form.is_admin_contact"
              :true-value="true"
              :false-value="false"
              label-position="right"
              name="is_admin_contact"
            />
          </d-card-row>

          <d-card-row>
            <v-input-switch
              v-model="form.can_receive_notifications"
              :true-value="true"
              :false-value="false"
              label-position="right"
              name="can_receive_notifications"
            />
          </d-card-row>

          <d-card-row>
            <button
              class="button is-primary"
              type="submit"
            >
              {{ $t("save") }}
            </button>
          </d-card-row>
        </v-form>
      </d-card>
    </div>
  </div>
</template>

<script>
import { fillFields } from "@/services/helpers";

export default {
  props: {
    owner_id: {
      required: true,
      type: Number,
    },
    action: {
      type: String,
      required: true,
    },
    model: {
      default: null,
      type: Object,
    },
  },
  data() {
    return {
      form: {
        name: "",
        phone: "",
        email: "",
        password: "",
        assigned_task: "",
        role: "",
        birthday: "",
        owner_id: this.owner_id,
        is_admin_contact: false,
        can_receive_notifications: true,
      },
    };
  },
  computed: {
    endpoint() {
      if (this.action === "create") {
        return {
          method: "post",
          url: this.$laravel.route("api.owner-contacts.store", this.owner_id),
        };
      }
      if (this.action === "edit") {
        return {
          method: "patch",
          url: this.$laravel.route("api.owner-contacts.update", {
            owner: this.owner_id,
            owner_contact: this.model.id,
          }),
        };
      }
      return null;
    },
    passwordLabel() {
      return this.action === "create"
        ? this.$t("attributes.password").capitalize()
        : this.$t("attributes.password").capitalize() +
            " (" +
            this.$t("leave_empty_to_keep_current").capitalize() +
            ")";
    },
  },
  created() {
    if (this.action === "edit") {
      this.form = fillFields(this.form, this.model);
    }
  },
};
</script>
